import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {connectToJSContext} from "../utils.jsx";
import Footer from "../footer/index.jsx";
import Navigation from "../navigation/index.jsx";
import AboutMeBio from "../aboutmebio/index.jsx";
import {AboutMeUserCustomContent, AboutMeOrgCustomContent} from "../custom_content/index.jsx";
import TeamMembers from '../team_members/index.jsx';
import {AboutMeHero} from "../hero/index.jsx";
import Locations from "../locations/index.jsx";
import ContactForm from "../contact_form/index.jsx";
import {getAboutMeUrl} from './selectors.js';
import { ABOUT_PAGE } from '../constants';

const AboutPage = ({
    showOrgCustomContent,
    showUserCustomContent,
    moduleOrder,
    aboutMeUrl
}) => {
    const mapModuleNameToComponent = {
        [ABOUT_PAGE.MODULES.ABOUT_HERO]: AboutMeHero,
        [ABOUT_PAGE.MODULES.ABOUT_BIO]: AboutMeBio,
        [ABOUT_PAGE.MODULES.ABOUT_ORG_CUSTOM_CONTENT]: showOrgCustomContent && AboutMeOrgCustomContent,
        [ABOUT_PAGE.MODULES.ABOUT_USER_CUSTOM_CONTENT]: showUserCustomContent && AboutMeUserCustomContent,
        [ABOUT_PAGE.MODULES.ABOUT_LOCATIONS]: Locations,
        [ABOUT_PAGE.MODULES.ABOUT_CONTACT_FORM]: ContactForm,
        [ABOUT_PAGE.MODULES.ABOUT_TEAM]: TeamMembers
    };

    return (
        <div>
            <Navigation currentPage={aboutMeUrl}/>
            <div id="maincontent" role="main">
                {moduleOrder.map((moduleName, i) => {
                    const Component = mapModuleNameToComponent[moduleName];
                    return Component && <Component key={i} />;
                })}
            </div>
            <Footer />
        </div>
    );
};

AboutPage.defaultProps = {
    moduleOrder: [
        ABOUT_PAGE.MODULES.ABOUT_HERO,
        ABOUT_PAGE.MODULES.ABOUT_BIO,
        ABOUT_PAGE.MODULES.ABOUT_ORG_CUSTOM_CONTENT,
        ABOUT_PAGE.MODULES.ABOUT_USER_CUSTOM_CONTENT,
        ABOUT_PAGE.MODULES.ABOUT_CONTACT_FORM,
        ABOUT_PAGE.MODULES.ABOUT_TEAM
    ]
};

AboutPage.propTypes = {
    showOrgCustomContent: PropTypes.bool,
    showUserCustomContent: PropTypes.bool,
    moduleOrder: PropTypes.arrayOf(
        PropTypes.oneOf(_.values(ABOUT_PAGE.MODULES)).isRequired
    )
};

const mapStateToProps = (state) => ({
    showOrgCustomContent: !_.isEmpty(state.theme_data.about_page.custom_content),
    showUserCustomContent: !_.isEmpty(state.profile.about_me_custom_content),
    moduleOrder: state.theme_data.about_page.modules &&
        _.flatten(_.pluck(state.theme_data.about_page.modules, 'module')),
    aboutMeUrl: getAboutMeUrl(state.theme_data.nav.main_navigation_links)
});

export default connectToJSContext(mapStateToProps)(AboutPage);



// WEBPACK FOOTER //
// ./components/about_page/index.jsx